import React, { useRef, useState } from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  IconButton,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CloseIcon from "@mui/icons-material/Close";
import Paper from "@mui/material/Paper";
import { MoneyFormat, MoneyFormatv3 } from "../../library/MoneyFormat";
import { useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { getTransactionMaster } from "../../graphql/queries";
import { getTransactionMasterCustom } from "../../graphql";
import { useThemes } from "../Theme/theme";

const style = {
  position: "relative",
  // top: "50%",
  // left: "150%",
  // transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  // p: 4,
  outline: "none",
  width: "100%",
  // width: 500,
  // marginTop: 15,
};

const headCell = [
  {
    id: "particulars",
    label: "Particulars",
    width: "300px",
    align: "left",
  },
  {
    id: "debit",
    label: "Debit",
    width: "150px",
    align: "right",
  },
  {
    id: "credit",
    label: "Credit",
    width: "150px",
    align: "right",
  },
];

const JournalToolTip = ({ journalTransID, accountDetails }) => {
  
  const [entries, setEntries] = useState([]);
  const { theme } = useThemes()
  function delay(seconds) {
    return new Promise(resolve => setTimeout(resolve, seconds * 1000));
}


  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;

    async function getTransaction() {
      try {
        await delay(0.81); // Simulate a delay
        if (!isMounted.current) return;
        const res = await API.graphql(
          graphqlOperation(getTransactionMasterCustom, {
            transactionid: journalTransID,
          })
        );

        if (!isMounted.current) return;
        let entryData = res.data.getTransactionMaster[0]?.relatedtransactiondetails;
        entryData.map((ele) => {
          accountDetails.map((subele) => {
            if (ele.accountid == subele.accountsid) {
              ele.accountname = subele.accountname;
              ele.sortamount =
                ele.creditamount == 0 ? ele.debitamount : ele.creditamount;
            }
          });
        });
        entryData = [...entryData]?.sort((a, b) => b.sortamount - a.sortamount);
        setEntries(entryData);
      } catch (error) {
        if (isMounted.current) {
          console.log('error', error);
        }
      }
    }

    getTransaction();

    return () => {
      isMounted.current = false;
    };
  }, [journalTransID, accountDetails, setEntries]);

  return (
    <Box
      sx={{
        backgroundColor: "transparent",
        padding: "1px",
        height: { xs: "400px", sm: "auto" },
        overflowY: { xs: "scroll", sm: "hidden" },
        ".MuiTableCell-root": {
          padding: "10px 10px",
          fontSize: "13px",
        },
      }}
    >
      <Box sx={style}>
        <TableContainer
          aria-setsize="small"
          component={Paper}
          sx={{
            overflowY: "auto",
            minWidth: "100%",
            maxHeight: 250,
            "&::-webkit-scrollbar": {
            },
          }}
        >
          <Table sx={{}} aria-label="simple table" stickyHeader>
            <TableHead sx={{ color: theme.palette.secondary.main }}>
              <TableRow>
                {headCell.map((column, ind) => {
                  return (
                    <TableCell
                      key={ind}
                      align={column.align}
                      sx={{
                        backgroundColor: theme.palette.secondary.main,
                        color: "#FFF",
                        whiteSpace:"nowrap"
                      }}
                    >
                      {column.label}{" "}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {entries
                .sort((p1) =>
                  p1.debitamount !== 0 ? -1 : p1.creditamount == 0 ? 0 : 1
                )
                .map((ele, ind) => {
                  return (
                    <TableRow key={ind}>
                      {ele.debitamount == 0 && ele.creditamount == 0 ? (
                        <></>
                      ) : (
                        <>
                          <TableCell
                            size="small"
                            sx={{
                              fontWeight: "bold",
                              color:
                                ele.debitamount !== 0 ? "#396afc" : "#20e0cf",
                              minWidth: "300px",
                              maxWidth: "600px",

                              height: "0px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {ele.debitamount !== 0
                              ? ele.accountname + " " + "Dr"
                              : "To" + " " + ele.accountname}
                          </TableCell>
                          <TableCell
                            align="right"
                            size="small"
                            sx={{
                              fontWeight: "bold",
                              color: "#396afc",
                              width: "30px",
                              height: "0px",
                            }}
                          >
                            {ele.debitamount == 0
                              ? " "
                              : MoneyFormatv3(
                                Number(ele.debitamount).toFixed(2),
                                "en-IN"
                              )}
                          </TableCell>
                          <TableCell
                            align="right"
                            size="small"
                            sx={{
                              fontWeight: "bold",
                              color: "#20e0cf",
                              width: "30px",
                              height: "0px",
                            }}
                          >
                            {ele.creditamount == 0
                              ? " "
                              : MoneyFormatv3(
                                Number(ele.creditamount).toFixed(2),
                                "en-IN"
                              )}
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  );
                })}

              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    color: "#00000",
                    width: "30px",
                    height: "0px",
                  }}
                >
                  Total
                </TableCell>
                <TableCell
                  align="right"
                  size="small"
                  sx={{
                    fontWeight: "bold",
                    color: "#396afc",
                    width: "30px",
                    height: "0px",
                  }}
                >
                  {MoneyFormatv3(entries.reduce((acc, ele) => acc + ele?.debitamount, 0))}
                </TableCell>
                <TableCell
                  align="right"
                  size="small"
                  sx={{
                    fontWeight: "bold",
                    color: "#20e0cf",
                    width: "30px",
                    height: "0px",
                  }}
                >
                  {MoneyFormatv3(entries.reduce((acc, ele) => acc + ele?.creditamount, 0))}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default JournalToolTip;
